import React from 'react'
import {
  IonListHeader, IonItem, IonInput, IonRow, IonCol, IonToggle,
} from '@ionic/react'
import { FormTitle } from '../maps/StyledContainers'

const OvernightDetails = ({
  showOvernight, setShowOvernight, optionalInput, handleOptionalInput,
}) => (
  <>
    <IonListHeader style={{ marginTop: '20px' }}>
      <IonRow style={{ width: '100%' }} className='ion-justify-content-between ion-align-items-center'>
        <IonCol size={8}>
          <h2 style={{ fontSize: '1.4rem' }}>Overnight Details</h2>
        </IonCol>
        <IonCol size={4}>
          <IonToggle onIonChange={(e) => setShowOvernight(e.target.checked)} checked={showOvernight} />
        </IonCol>
      </IonRow>
    </IonListHeader>
    {showOvernight && (
      <>
        <IonListHeader>
          <FormTitle>
            <h3 style={{ fontSize: '1rem' }}>Driver Accommodation</h3>
          </FormTitle>
        </IonListHeader>
        <IonItem>
          <IonInput onIonChange={handleOptionalInput} value={optionalInput.driverAccommodation} name='driverAccommodation' type='text' placeholder='Accomodation Name' />
        </IonItem>
        <IonItem>
          <IonInput onIonChange={handleOptionalInput} value={optionalInput.driverAccommodationLocation} name='driverAccommodationLocation' type='text' placeholder='Accommodation address' />
        </IonItem>
        <IonItem>
          <IonInput onIonChange={handleOptionalInput} value={optionalInput.driverAccommodationPhone} name='driverAccommodationPhone' type='text' placeholder='Phone' />
        </IonItem>
        <IonListHeader>
          <FormTitle>
            <h3 style={{ fontSize: '1rem' }}>Passengers Accommodation</h3>
          </FormTitle>
        </IonListHeader>
        <IonItem>
          <IonInput onIonChange={handleOptionalInput} value={optionalInput.passengerAccommodation} name='passengerAccommodation' type='text' placeholder='Accomodation Name' />
        </IonItem>
        <IonItem>
          <IonInput onIonChange={handleOptionalInput} value={optionalInput.passengerAccommodationLocation} name='passengerAccommodationLocation' type='text' placeholder='Accommodation address' />
        </IonItem>
        <IonItem>
          <IonInput onIonChange={handleOptionalInput} value={optionalInput.passengerAccommodationPhone} name='passengerAccommodationPhone' type='text' placeholder='Phone' />
        </IonItem>
      </>
    )}
  </>
)

export default OvernightDetails
